function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint no-script-url:0 */
import React, { Component } from 'react';
import s from './onboardingLayout.scss';
import cx from 'classnames';
import { TransitionGroup } from 'react-transition-group';
import FadeUp from '../../animations/fadeUp';
import { Heading } from 'wix-style-react';

var HideHeaderControl = function HideHeaderControl(props) {
  var children = props.children,
      show = props.show;
  return show ? children : null;
};

var OnboardingLayout = /*#__PURE__*/function (_Component) {
  _inheritsLoose(OnboardingLayout, _Component);

  function OnboardingLayout() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = OnboardingLayout.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        showHeader = _this$props.showHeader,
        contentComponent = _this$props.contentComponent,
        titleKey = _this$props.titleKey,
        titleUniqueKey = _this$props.titleUniqueKey,
        subTitleKey = _this$props.subTitleKey,
        subTitleUniqueKey = _this$props.subTitleUniqueKey,
        stepsIndicatorComponent = _this$props.stepsIndicatorComponent,
        containerClass = _this$props.containerClass,
        stepsClass = _this$props.stepsClass,
        titleClass = _this$props.titleClass,
        subTitleClass = _this$props.subTitleClass,
        logoContainerClass = _this$props.logoContainerClass,
        wixLogoLink = _this$props.wixLogoLink,
        inBizMgr = _this$props.inBizMgr,
        _this$props$bng = _this$props.bng,
        bng = _this$props$bng === void 0 ? false : _this$props$bng,
        isMobile = _this$props.isMobile;
    var wixLogoComponent = /*#__PURE__*/React.createElement("a", {
      href: wixLogoLink
    }, /*#__PURE__*/React.createElement("div", {
      className: s.wixLogo
    }));
    var stepsComponent = stepsIndicatorComponent && /*#__PURE__*/React.createElement("div", {
      className: stepsClass
    }, stepsIndicatorComponent);
    return /*#__PURE__*/React.createElement("div", {
      "data-aid": "onboarding-container",
      className: cx(s.onboardingContainer, containerClass)
    }, /*#__PURE__*/React.createElement(HideHeaderControl, {
      show: showHeader
    }, !inBizMgr && /*#__PURE__*/React.createElement("div", {
      className: cx(s.wixLogoContainer, logoContainerClass)
    }, wixLogoComponent), stepsComponent, /*#__PURE__*/React.createElement("div", {
      className: cx(titleClass)
    }, /*#__PURE__*/React.createElement(TransitionGroup, null, /*#__PURE__*/React.createElement(FadeUp, {
      key: titleUniqueKey ? titleUniqueKey : titleKey
    }, /*#__PURE__*/React.createElement(Heading, {
      appearance: "H1"
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(s.titleFont, (_cx = {}, _cx[s.bng] = bng, _cx))
    }, titleKey))))), /*#__PURE__*/React.createElement("div", {
      className: cx(subTitleClass)
    }, /*#__PURE__*/React.createElement(TransitionGroup, null, /*#__PURE__*/React.createElement(FadeUp, {
      delay: 100,
      key: subTitleUniqueKey ? subTitleUniqueKey : subTitleKey
    }, /*#__PURE__*/React.createElement(Heading, {
      appearance: isMobile ? 'H2' : 'H3'
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(s.subtitleFont)
    }, " ", subTitleKey)))))), /*#__PURE__*/React.createElement("div", {
      "data-aid": "onboarding-content",
      className: s.content
    }, contentComponent));
  };

  return OnboardingLayout;
}(Component);

export { OnboardingLayout as default };